var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-anchor",style:(_vm.styles),attrs:{"id":_vm.$attrs._id}},[_c('div',{staticClass:"tag-line",style:(_vm.lineStyle)}),(_vm.tailPosition !== 'none')?_c('div',{staticClass:"tag-dot",style:({ backgroundColor: _vm.backgroundColour})}):_vm._e(),_c('div',{ref:"el",staticClass:"tag-basic",class:[
      { 'tag-basic--box-shadow' : _vm.boxShadow },
      { 'tag-basic--sold-out' : _vm.showSoldLabel },
    ],style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.label[_vm.activeLanguage.code])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }